<template>
	<div id='top'>
		<header><h1>Vivere Rovigo</h1></header>
		<h3 id='subtitle'>I dati per crescere</h3>
		<div id='project_info' class='hidden_info'>
			<h3>Visualizzare Rovigo</h3>
			<p>
				Questo progetto si concentra sulla visualizzazione di statistiche pubbliche sulla città di Rovigo. In particolare, il suo focus è la qualità della vita nei quartieri della città.
			</p>
			<p>
				Esso vuole fornire uno strumento che permettesse di verificare l'esistenza di aree <em>privilegiate</em>, dove pochi possono godere delle migliori condizioni. Ad esempio, esso permette di controllare se i quartieri che ospitano il maggior numero di famiglie numerose abbiano a disposizione aree vegetate a sufficienza, e se i quartieri con una maggiore percentuale di non italian* siano abitabili in termini di spazio e di verde.
			</p>
			<p>
				L'idea fondamentale del progetto è di essere uno strumento utile per apportare cambiamenti che migliorino la vita di tutte le aree della città.
			</p>
			<p id='footnote'> Visualizzazione elaborata nell’ambito del contest “URBAN DATAVIZ CONTEST - ROVIGO promosso da AIAP e Urban Digital Center - InnovationLab Rovigo in collaborazione con Università Iuav di Venezia, basata sui dati aperti dei Comuni di Rovigo, Adria e Villadose. <a href='https://dati.veneto.it'>fonte</a>
			</p>
		</div>
		<span id='info_icon' class="material-icons hidden_info">info</span>
		<span id='rovigo_glance_icon' class="material-icons">arrow_downward</span>
		<div id='rovigo_glance' class='hidden_glance'>
			<h2>Rovigo a colpo d'occhio</h2>
			<div id='rovigo_glance_columns'>
				<div id='rovigo_glance_1' class='rovigo_glance_column'>
					<BarchartROV name='Famiglie per n° di componenti' id='rovigo_fam_components' district='rovigo'/>
					<BarchartgroupedROV name='Demografia' id='rovigo_demography' district='rovigo'/> 
				</div>
				<div id='rovigo_glance_2' class='rovigo_glance_column'>
					<BarchartdenROV name='Densità popolazione (abitanti/km^2)' id='rovigo_density' district='rovigo'/> 
					<PercentageareaROV name='Percentuale di verde' id='rovigo_green' district='rovigo'/> 	
				</div>
			</div>
		</div>
	</div>
	<Map @showDists='onShowDists'/>
	<div id='distrs_info_container'>
		<Districtinfo v-for="d in districts" :district='d'/>
		<!-- <Districtinfo district='boara_polesine'/> -->
	</div>
	<div id='message'>
		<div class='info_header'>
			<h2>Clicca su due o più quartieri per confrontarli</h2>
		</div>
	</div>
</template>

<script>
import Map from './components/Map.vue'
import Barchartgrouped from './components/Barchartgrouped.vue'
import Barchart from './components/Barchart.vue'
import BarchartgroupedROV from './components/BarchartgroupedROV.vue'
import BarchartROV from './components/BarchartROV.vue'
import BarchartdenROV from './components/BarchartdenROV.vue'
import PercentageareaROV from './components/PercentageareaROV.vue'
import Percentage from './components/Percentage.vue'
import Percentagearea from './components/Percentagearea.vue'
import Districtinfo from './components/Districtinfo.vue'
import Percentagedistrarea from './components/Percentagedistrarea.vue'

export default {
	name: 'App',
	data() {
		return {
			districts : [], 
			modality : null
		}
	},
	components: {
		Map, 
		Barchartgrouped, 
		Barchart,
		BarchartgroupedROV, 
		BarchartROV,
		PercentageareaROV,
		Percentage,
		Percentagearea,
		Districtinfo,
		Percentagedistrarea,
		BarchartdenROV
	},
	mounted() {
		let component = this
		//component.add_filters()
		let info_icon = $('#info_icon'),
			infos =  $('#project_info')

		info_icon.on('click', e => {
			info_icon.toggleClass('hidden_info')
			infos.toggleClass('hidden_info')
		})

		let rovigo_icon = $('#rovigo_glance_icon'),
			rovigo_glance = $('#rovigo_glance')

		rovigo_icon.on('click', e => {
			rovigo_glance.toggleClass('hidden_glance')
			if (rovigo_glance.hasClass('hidden_glance')) {
				rovigo_icon.html('arrow_downward')
			} else {
				rovigo_icon.html('arrow_upward')
			}
		})
	},
	methods : {
		onShowDists(dists) {
			this.districts = dists
			if (this.districts.length > 0) {
				$('#message').addClass('hidden')
			} else {
				$('#message').removeClass('hidden')
			}
		}
	}
}
</script>

<style>
* {
	margin: 0;
	box-sizing: border-box;
	font-family: 'Recursive', sans-serif;
	font-size: 16px;
	background-color: #000;
}

header {
	background-color: #000;
	color: #FFF;
	font-weight: 600;
	font-size: 24px;
	padding: .5rem;
	padding-left: 24px;
	text-align: left;
}

h1 {
	font-size: 24px;
	font-weight: 800;
}

h2 {
	font-size: 22px;
	font-weight: 800;
}

a {
	color: #000;
}

span, h2, em, h3, a, svg {
	background-color: #FFF;
}

#top {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 50;
}

#subtitle {
	padding-left: 24px;
	text-align: left;
	color: #FFF;
	background-color: #000;
}

.hidden {
	display: none;
}

#app {
	font-weight: 200;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

#project_info {
	width: 30vw;
	position: absolute;
	top: 0;
	right: 0;
	background-color: #FFF;
	padding: 48px 24px 24px;
	text-align: left;
	z-index: 4;
	display: block;
	max-height: 100vh;
	overflow: scroll;
}

#project_info h3 {
	font-size: 20px;
}

#project_info p {
	font-size: 16px;
	padding-top: 16px;
}

#project_info.hidden_info {
	display: none;
}

p#footnote {
	font-size: 12px;
}

p#footnote a {
	font-size: 12px;
}

#info_icon {
	position: absolute;
	top: 12px;
	right: 12px;
	color: #000;
	background-color: #FFF;
	z-index: 5;
	cursor: pointer;
		-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			 -khtml-user-select: none; /* Konqueror HTML */
				 -moz-user-select: none; /* Old versions of Firefox */
					-ms-user-select: none; /* Internet Explorer/Edge */
							user-select: none; 
}

#info_icon.hidden_info {
	color: #FFF;
	background-color: #000;
}

#rovigo_glance_icon {
	background-color: #000;
	color: #FFF;
	width: 100%;
	padding: 8px;
	cursor: pointer;
	-webkit-touch-callout: none; 
		-webkit-user-select: none; 
		 -khtml-user-select: none; 
			 -moz-user-select: none; 
				-ms-user-select: none; 
						user-select: none;
}

#rovigo_glance {
	background-color: #FFF;
	text-align: left;
	width: 100%;
	position: absolute;
	top: 104px;
	display: block;
	z-index: 3;
	overflow: scroll;
	max-height: calc(100vh - 104px);
	padding: 12px 0 16px;
}

#rovigo_glance.hidden_glance {
	display: none;
}

#rovigo_glance h2 {
	margin-bottom: 16px;
	margin-left: calc(50vw - 440px - 32px - 8px);
}

#rovigo_glance_columns {
	text-align: center;
}

.rovigo_glance_column {
	display: inline-block;
	vertical-align: top;
}

.rovigo_glance_column:first-child {
	margin-right: 24px;
}

.plot_title {
	text-align: left;
	padding: 4px;
	margin-left: 16px;
}

#distrs_info_container {
	position: absolute;
	top: calc(100vh - 24px - 19px - 1rem);
	text-align: left;
	width: 100vw;
	white-space: nowrap;
	overflow-x:  scroll;
	direction: rtl;
	background-color: #FFF;
}

.info_header {
	background-color: #000;
	color: #FFF;
	padding: 20px;
	width: calc(440px + 40px);
}	
.info_header h2{
	font-size: 16px;
	background-color: #000;
}

.legend_p {
	white-space: normal;
}
#message {
	display: block;
	position: absolute;
	width: 100vw;
	text-align: center;
	background-color: #000;
	top: calc(100vh - 24px - 19px - 1rem);
	padding-left: calc(50vw - 220px - 20px);
	-webkit-touch-callout: none; 
		-webkit-user-select: none; 
		 -khtml-user-select: none; 
			 -moz-user-select: none; 
				-ms-user-select: none; 
						user-select: none;
}

#message.hidden {
	display: none;
}
.message .info_header{
	width: 100vw;
}

div.mapboxgl-ctrl-bottom-left,  div.mapboxgl-ctrl-bottom-right{
	background-color: #000;
	padding: 4px;
}
div.mapboxgl-ctrl {
	background-color: transparent;
}

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
	background-color: #000;
	padding: 0;
}

.mapboxgl-ctrl-attrib-button, div.mapboxgl-ctrl-attrib-inner{
	background-color: transparent;
}

a.mapboxgl-ctrl-logo {
	background-color: #000;
}

.mapboxgl-ctrl-attrib-inner a {
	background-color: transparent;
	color: #FFF;
	font-size: 10px;
}

.mapboxgl-ctrl-bottom-left .mapboxgl-ctrl {
	margin:  0;
	padding: 0;
}
</style>
